import apiFactory from './api';

// No iPad, "localhost" é o próprio aparelho. A API local está no computador
// que serviu a página, então o host acompanha o endereço aberto no navegador.
function apiUrlAcessivelDesteAparelho(url) {
  if (typeof window === 'undefined' || !url) return url;

  let api;
  try {
    api = new URL(url);
  } catch {
    return url;
  }

  const apiNoLoopback =
    api.hostname === 'localhost' || api.hostname === '127.0.0.1';
  const paginaNoLoopback =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  if (!apiNoLoopback || paginaNoLoopback) return url;

  api.hostname = window.location.hostname;
  return api.href.replace(/\/$/, '');
}

const api = apiFactory({
  api_url: apiUrlAcessivelDesteAparelho(
    process.env.REACT_APP_API_URL || 'https://api.pro.agroger.com.br',
  ),
  has_user_header: true,
});

export default api;
